<template>
  <div>

    <b-form inline @submit.prevent="" class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text class="semester-input-group">
          Semester
        </b-input-group-prepend>
        <b-form-select v-model="term"
                      @input="changeTerm" 
                      :options="terms"
                      value-field="termId"
                      text-field="description"
                      />
      </b-input-group>
    </b-form>
    <bar-chart :chart-data="itemsData" :options="options"></bar-chart>
  </div>
</template>

<script>
import * as _ from "lodash";
import opportunityReportsApi from "../../api/opportunityReporting";
import termsApi from "../../api/terms";

export default {
  data() {
    return {
      terms: [],
      term: null,
      items: [],
      // options: {
      //   scaleOverride: true,
      //   scaleStartValue: 0,
      //   scaleStepWidth: 1
      // },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      },
      colors: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)"
      ],
      borderColors: [
        "rgba(255,99,132,1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)"
      ]
    };
  },

  // props: {
  //   items: {
  //     type: Object,
  //     required: true
  //   }
  // },

  computed: {
    itemsData: function() {
      var that = this;

      var formattedData = {
        labels: [],
        datasets: []
      };
      var colorIndex = 0;

      var dataset = {
        label: "Timeline",
        borderWidth: 1,
        data: [],
        backgroundColor: [],
        borderColor: []
      };

      _.forEach(this.items, term => {
        dataset.backgroundColor.push(this.colors[colorIndex]);
        dataset.borderColor.push(this.borderColors[colorIndex]);
        dataset.data.push(term.savedToIntent);
        formattedData.labels.push("Saved to Intent");
        colorIndex++;

        dataset.backgroundColor.push(this.colors[colorIndex]);
        dataset.borderColor.push(this.borderColors[colorIndex]);
        dataset.data.push(term.intentToTasksOpen);
        formattedData.labels.push("Intent to Tasks Open");
        colorIndex++;

        dataset.backgroundColor.push(this.colors[colorIndex]);
        dataset.borderColor.push(this.borderColors[colorIndex]);
        dataset.data.push(term.tasksOpenToSubmitted);
        formattedData.labels.push("Tasks Open to Submitted");
        colorIndex++;

        dataset.backgroundColor.push(this.colors[colorIndex]);
        dataset.borderColor.push(this.borderColors[colorIndex]);
        dataset.data.push(term.submittedToApproved);
        formattedData.labels.push("Submitted to Approved");
        colorIndex++;

        dataset.backgroundColor.push(this.colors[colorIndex]);
        dataset.borderColor.push(this.borderColors[colorIndex]);
        dataset.data.push(term.approvedToClosed);
        formattedData.labels.push("Approved to Closed");
        colorIndex++;
        // if (!formattedData.labels.includes(term.termCode)) {
        //   formattedData.labels.push(term.termCode);
        // }
      });

      formattedData.datasets.push(dataset);

      // if (colorIndex < that.colors.length - 1) {
      //   colorIndex++;
      // } else {
      //   colorIndex = 0;
      // }

      return formattedData;
    }
  },

  methods: {
    changeTerm() {
      this.getData();
    },
    getData() {
      if (this.term) {
        opportunityReportsApi
          .getStudentOpportunityTimeline(this.term)
          .then(response => {
            this.items = response.data;
          });
      }
    }
  },

  created() {
    termsApi.getPastTerms().then(response => {
      this.terms = response.data;
    });
    this.getData();
  }
};
</script>

<style scoped>
</style>
